import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { Product, Variant } from 'shared/types/product';

const getVariantPrice = (selectedVariant: Variant) => {
  if (selectedVariant.price) {
    return CurrencyHelpers.formatForCurrency(selectedVariant?.price);
  }
  return undefined;
};

const addToGiftRegistry = (
  productData: Product,
  selectedVariant: Variant,
  quantity: number,
  pdpNavigationLink: string,
) => {
  const gift = {
    Title: productData?.name,
    ImageUrl: selectedVariant?.images?.[0] || '#',
    URL: pdpNavigationLink,
    Price: getVariantPrice(selectedVariant),
    Quantity: quantity,
    HideSize: true,
    HideColor: true,
    Color: selectedVariant?.attributes?.actualColor,
    Size: selectedVariant?.attributes?.actualSize,
    SKU: selectedVariant?.sku,
    Options: [],
  };

  //@ts-ignore
  const myregistrysdk = new MyRegistrySDK(gift);
  myregistrysdk.on('gift_value_changed', function (e: unknown) {
    console.log(e);
  });
  myregistrysdk.on('popup_showing', function (e: unknown) {
    console.log(e);
    document.documentElement.style.overflow = 'hidden';
  });
  myregistrysdk.on('popup_closed', function (e: unknown) {
    console.log(e);
    document.documentElement.style.overflow = 'initial';
  });

  myregistrysdk.on('popup_showed', function (e: unknown) {
    console.log(e);
  });
  myregistrysdk.on('gift_option_bound', function (e: unknown) {
    console.log(e);
  });

  if (myregistrysdk) myregistrysdk.showPopup();
};

export default { addToGiftRegistry };
